import { GraphQLError } from "graphql";
import { ErrorOption } from "react-hook-form";

export default class FormValidationError extends GraphQLError {
    constructor(public errors: Record<string, ErrorOption>) {
        super("Invalid input");
    }
}
